import { t } from '@moovly/i18n';
import { Button, useModal } from '@moovly/ui';
import * as React from 'react';
import useUsersSearch from '../hooks/useUsersSearch';

import AddUserModal from '../modals/AddUserModal';

interface AddUserButtonContainerProps {
  label?: string;
}

const AddUserButtonContainer: React.FC<AddUserButtonContainerProps> = ({ label = t('users.add.button') }) => {
  const { openModal, isOpen, ...other } = useModal();
  const { isSearch } = useUsersSearch();
  if (isSearch) {
    return null;
  }
  return (
    <>
      <Button onClick={openModal} label={label} />
      {isOpen && <AddUserModal {...other} />}
    </>
  );
};

export default AddUserButtonContainer;
